import { DualAxes, Line } from "@ant-design/plots";
import React, { useEffect, useState } from "react";

interface IProps {
  chartLabel: string;
  value: any;
  unit: string;
  order?: string[];
}
const Charts: React.FC<IProps> = (props) => {
  let { value = {}, unit, chartLabel, order } = props;

  // Filter out 'total' and 'unit' keys and prepare for sorting
  const newValue = { ...value };
  if (newValue.total) delete newValue["total"];
  const apiUnit = newValue.unit ? newValue.unit : unit;
  if (newValue.unit) delete newValue["unit"];

  // Sort the keys based on the provided order
  const sortedKeys = order
    ? order.filter((key) => key in newValue)
    : Object.keys(newValue);

  // Map the sorted keys to the data array
  const data = sortedKeys.map((i: string) => {
    let _value: number = Number(newValue[i]);
    // if (chartLabel === "sessionLength" || chartLabel === "avgLength") {
    //   _value = Number(Number(newValue[i]).toFixed(2));
    // }
    // if (chartLabel === "avgEnergy" || chartLabel === "energy") {
    //   _value = Number(Number(newValue[i]).toFixed(2));
    // }
    return {
      Date: i,
      value: _value,
    };
  });

  // Calculate the length of the longest label in pixels
  const longestLabelLength = Math.max(...data.map(item => getTextWidth(item.Date, '6px Arial')));

  const config: any = {
    data,
    padding: [20, longestLabelLength, 35, 40],
    xField: "Date",
    yField: "value",
    tooltip: {
      formatter: (datum) => {
        return { name: "value", value: datum.value + " " + apiUnit };
      },
    },
    yAxis: {
      tickCount: 2,
      grid: {
        line: false,
        label: false,
      },
    },
    xAxis: {
      tickCount: 2,
      tickLine: false,
      range: [0, 1],
    },
  };

  return <Line {...config} />;
};

// Function to calculate the width of a text string in pixels
function getTextWidth(text: string, font: string) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
  }
  return 0;
}

export default Charts;
